import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const deleteGlobalField = async (fieldKey: string): Promise<void> => {
	await performDeleteRequest(`/rest/polaris/global-fields/${fieldKey}`);
};
